import type { ServiceContractDto } from '@api/machines'

type CalculationParameters = {
  machinePrice: number
  margin: number
  overAllowanceSplit?: number
  serviceContract?: ServiceContractDto | null
}

export function calculateTargetPrice(params: CalculationParameters): number {
  const {
    machinePrice,
    margin,
    overAllowanceSplit = 0,
    serviceContract
  } = params

  const dnp = serviceContract?.dnp ?? 0

  const targetPrice = (machinePrice - dnp) / (1 - margin) + overAllowanceSplit

  return targetPrice
}
